import { Link } from "react-router-dom";

export const LogoMark = ({ className = "h-9 w-9" }) => (
  <svg viewBox="0 0 40 40" fill="none" className={className} aria-hidden="true">
    <rect x="2" y="2" width="36" height="36" rx="7" fill="#090D16" stroke="#FF5500" strokeWidth="3" />
    <path d="M9 12.5 14.5 28 20 17.5 25.5 28 31 12.5" stroke="#F8FAFC" strokeWidth="3.4" strokeLinecap="square" />
    <circle cx="31" cy="12.5" r="2.8" fill="#FF5500" />
  </svg>
);

export const Logo = () => (
  <Link to="/" data-testid="nav-logo-link" className="group flex items-center gap-3">
    <span className="transition-transform duration-500 group-hover:rotate-[-8deg]">
      <LogoMark />
    </span>
    <span className="leading-none">
      <span className="block font-display text-lg font-extrabold tracking-tight">WILKO TECH</span>
      <span className="hidden font-mono text-[10px] tracking-[0.3em] text-slate-400 sm:block">LTD · REPAIR BENCH</span>
    </span>
  </Link>
);
